import { useCallback } from 'react';

export function useIsReadyToReserve(state, reservationId) {
  const {
    newCustomerReady,
    customer,
    consents,
    paymentReady,
    paymentSelections,
    paymentOnBookingPercentage,
    additionalInformation,
    securityDepositAmount,
  } = state;

  return useCallback(() => {
    const hasCustomer = newCustomerReady || !!customer?.id;
    const hasPayment = paymentReady;
    const consentsAccepted = !!reservationId || Object.values(consents).every(Boolean);
    const partial = paymentSelections?.paymentModel === 'PARTIAL_PAYMENT';
    const hasPaymentPercentage = !partial || !!paymentOnBookingPercentage;
    const hasSecurityDeposit =  !!securityDepositAmount;
    const hasTimes =
      !!additionalInformation?.checkinTime &&
      !!additionalInformation?.checkoutTime;
    return hasCustomer && hasPayment && hasPaymentPercentage && hasSecurityDeposit && hasTimes && consentsAccepted;
  }, [
    newCustomerReady,
    customer,
    paymentReady,
    paymentSelections,
    consents,
    paymentOnBookingPercentage,
    additionalInformation,
    securityDepositAmount,
  ]);
}
